const defaultState = {
  listLoading: false,
  pageCount: 0,
  currentPageNumber: 0,
  entities: null,
  totalResult: 0,
  error: null,
};
export const actionTypes = {
  usersActionsFetched: 'USERS_ACTIONS_FETCHED',
  usersActionsAppended: 'USERS_ACTIONS_APPENDED',
  catchError: 'CATCH_ERROR'
};

export const usersActionsTableReducer = (state = defaultState, action) => {
  switch (action.type) {
    case actionTypes.usersActionsFetched: {
      const {totalPageCount, currentPageNumber, usersActions, totalResultCount} = action.payload;
      return {
        ...state,
        listLoading: false,
        pageCount: totalPageCount,
        currentPageNumber: currentPageNumber,
        entities: usersActions,
        totalResult: totalResultCount,
        error: null
      };
    }
    case actionTypes.usersActionsAppended: {
      const {totalPageCount, currentPageNumber, usersActions, totalResultCount} = action.payload;
      return {
        ...state,
        listLoading: false,
        pageCount: totalPageCount,
        currentPageNumber: currentPageNumber,
        entities: state.entities
          ? [...state.entities, ...usersActions]
          : [...usersActions],
        totalResult: totalResultCount,
        error: null
      };
    }
    case actionTypes.catchError: {
      const error = `USERS_ACTIONS: ${action.payload.error}`;
      return {...state, error};
    }
    default:
      return state;
  }
};

export const actions = {
  usersActionsFetched: (data) => ({
    type: actionTypes.usersActionsFetched,
    payload: data
  }),
  usersActionsAppended: (data) => ({
    type: actionTypes.usersActionsAppended,
    payload: data
  }),
  catchError: (error) => ({type: actionTypes.catchError, payload: {error}}),
};
